<template>
  <div class="md-layout">
    <template>
      <div
        v-if="isProgress"
        class="md-layout-item md-size-100 md-medium-size-100 bar-progress"
      >
        <md-progress-bar md-mode="indeterminate"></md-progress-bar>
      </div>
    </template>
    <div class="md-layout-item md-size-70 mx-auto md-small-size-100">
      <tabs
        id="settings"
        :tab-name="['Profile', 'Change Password', 'Settings']"
        color-button="warning"
      >
        <h4 slot="header-title" class="title">Edit profile</h4>
        <template slot="tab-pane-1">
          <template>
            <form>
              <md-card>
                <md-card-header class="md-card-header-icon">
                  <div class="card-icon">
                    <md-icon>perm_identity</md-icon>
                  </div>
                  <h4 class="title">Edit Profile</h4>
                </md-card-header>
                <md-card-content>
                  <div class="md-layout">
                    <div class="md-layout-item md-small-size-100 md-size-33">
                      <md-field>
                        <label>User Name</label>
                        <md-input
                          ref="name"
                          v-model="profile.name"
                          type="text"
                        ></md-input>
                      </md-field>
                    </div>
                    <div class="md-layout-item md-small-size-100 md-size-33">
                      <md-field>
                        <label>Email Address</label>
                        <md-input
                          ref="email"
                          v-model="profile.email"
                          type="email"
                        ></md-input>
                      </md-field>
                    </div>
                    <div class="md-layout-item md-small-size-100 md-size-33">
                      <md-field>
                        <label>Rol</label>
                        <md-input
                          v-model="role"
                          :disabled="isDisabled"
                          type="text"
                        ></md-input>
                      </md-field>
                    </div>
                    <div class="md-layout-item md-small-size-100 md-size-100">
                      <Autocomplete
                        label="Time Zone"
                        :options="time_zone"
                        :val="profile.timezone"
                        @updateValue="udpate_timezone"
                      />
                    </div>
                  </div>
                  <div class="md-layout-item md-small-size-100 md-size-100">
                    <md-button
                      :disabled="isDisabledbtn"
                      class="md-primary mt-4"
                      @click="updateProfile()"
                      >Update Profile</md-button
                    >
                  </div>
                </md-card-content>
              </md-card>
            </form>
          </template>
        </template>
        <template slot="tab-pane-2">
          <template>
            <form>
              <md-card>
                <md-card-header class="md-card-header-icon">
                  <div class="card-icon">
                    <md-icon>vpn_key</md-icon>
                  </div>
                  <h4 class="title">Change Password</h4>
                </md-card-header>
                <md-card-content>
                  <div class="md-layout">
                    <div class="md-layout-item md-small-size-100 md-size-33">
                      <md-field>
                        <label>Current Password</label>
                        <md-input
                          ref="current_password"
                          v-model="current_password"
                          type="password"
                        ></md-input>
                      </md-field>
                    </div>
                    <div class="md-layout-item md-small-size-100 md-size-33">
                      <md-field>
                        <label>New Password</label>
                        <md-input
                          ref="new_password"
                          v-model="new_password"
                          type="password"
                        ></md-input>
                      </md-field>
                    </div>
                    <div class="md-layout-item md-small-size-100 md-size-33">
                      <md-field>
                        <label>Confirmation Password</label>
                        <md-input
                          ref="confirmation_password"
                          v-model="confirmation_password"
                          type="password"
                        ></md-input>
                      </md-field>
                    </div>
                  </div>
                  <div class="md-layout-item md-small-size-100 md-size-100">
                    <md-button
                      :disabled="isDisabledbtn"
                      class="md-primary mt-4"
                      @click="updatePassword()"
                      >Update Password</md-button
                    >
                  </div>
                </md-card-content>
              </md-card>
            </form>
          </template>
        </template>
        <template slot="tab-pane-3">
          <template>
            <form>
              <md-card>
                <md-card-header class="md-card-header-icon">
                  <div class="card-icon">
                    <md-icon>settings</md-icon>
                  </div>
                  <h4 class="title">Settings</h4>
                </md-card-header>
                <md-card-content>
                  <div class="md-layout md-size-100">
                    <div v-for="setting in settings" :key="setting.key">
                      <div
                        v-if="setting.type == 'notifications'"
                        class="md-layout"
                      >
                        <div class="md-layout-item md-size-100">
                          <label>{{ setting.name }}</label>
                        </div>
                        <div
                          class="md-layout-item md-small-size-100 md-size-25"
                        >
                          <md-field>
                            <md-select
                              id="smsemail"
                              v-model="smsemail"
                              style="wigth:100%"
                              name="smsemail"
                            >
                              <md-option
                                v-for="item in option"
                                :key="item.id"
                                :value="item.name"
                                >{{ item.name }}</md-option
                              >
                            </md-select>
                          </md-field>
                        </div>
                        <div
                          class="md-layout-item md-small-size-100 md-size-25"
                        >
                          <md-field>
                            <md-input
                              ref="number"
                              v-model="value"
                              :min="1"
                              :inputtable="false"
                              :max="100"
                              type="number"
                              >{{ itemEdit.value }}</md-input
                            >
                          </md-field>
                        </div>
                        <div
                          class="md-layout-item md-small-size-100 md-size-20"
                        >
                          <md-field>
                            <md-select
                              id="typeday"
                              v-model="typeday"
                              style="wigth:100%"
                              name="typeday"
                            >
                              <md-option
                                v-for="item in fields"
                                :key="item.name"
                                :value="item.name"
                                >{{ item.name }}</md-option
                              >
                            </md-select>
                          </md-field>
                        </div>
                      </div>
                      <div
                        v-else-if="setting.type === 'number'"
                        class="md-layout-item md-small-size-100 md-size-25"
                      >
                        <md-field>
                          <label>{{ setting.name }}</label>
                          <md-input
                            v-model="setting.value"
                            :min="1"
                            :inputtable="false"
                            type="number"
                            >{{ setting.value }}</md-input
                          >
                        </md-field>
                      </div>

                      <div
                        v-else-if="setting.type === 'string'"
                        class="md-layout-item md-small-size-100 md-size-25"
                      >
                        <md-field>
                          <label>{{ setting.name }}</label>
                          <md-input v-model="setting.value">{{
                            setting.value
                          }}</md-input>
                        </md-field>
                      </div>
                    </div>
                  </div>

                  <md-button class="md-primary btn-edit" @click="updateSettings"
                    >Update</md-button
                  >
                </md-card-content>
              </md-card>
            </form>
          </template>
        </template>
      </tabs>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { Tabs } from '@/components'
import { Collapse } from '@/components'
import Autocomplete from './../../../components/Autocomplete'
import json from './../../../../timezones.json'
export default {
  name: 'EditProfileForm',
  components: {
    Tabs,
    Collapse,
    Autocomplete
  },
  data() {
    return {
      profile: {},
      role: null,
      isDisabled: true,
      isProgress: false,
      isDisabledbtn: false,
      current_password: '',
      new_password: '',
      confirmation_password: '',
      settings: [],
      showDialogEditSetting: false,
      showDialogNewSetting: false,
      fields: [],
      option: [
        {
          id: 0,
          name: 'sms'
        },
        {
          id: 1,
          name: 'email'
        }
      ],
      itemEdit: {},
      type: '',
      smsemail: '',
      value: '',
      typeday: '',
      id_notification: null,
      user_id: null,
      time_zone: json
    }
  },
  mounted() {
    console.log(json)
    this.loadProfile()
    this.loadSettings()
  },
  methods: {
    udpate_timezone(newValue) {
      this.profile.timezone = newValue
    },
    loadProfile() {
      let self = this
      let url = process.env.VUE_APP_API_URL + '/user/profile'
      axios
        .post(
          url,
          {
            id: this.$store.state.id
          },
          {
            headers: {
              Accept: 'application/json',
              Authorization: 'Bearer ' + this.$store.state.token
            }
          }
        )
        .then(response => {
          this.profile = response.data.user
          if (this.profile.role_id == 1) {
            this.role = 'Admin'
          }
          if (this.profile.role_id == 2) {
            this.role = 'Operator'
          }
          if (this.profile.role_id == 3) {
            this.role = 'Agent'
          }
          this.$forceUpdate()
        })
        .catch(error => {
          console.log(error)
        })
    },

    updateProfile() {
      if (this.validateData()) {
        this.isProgress = true
        this.isDisabledbtn = true
        let url = process.env.VUE_APP_API_URL + '/user/profile/update'
        axios
          .post(
            url,
            {
              id: this.$store.state.id,
              username: this.profile.name,
              email: this.profile.email,
              timezone: this.profile.timezone
            },
            {
              headers: {
                Accept: 'application/json',
                Authorization: 'Bearer ' + this.$store.state.token
              }
            }
          )
          .then(response => {
            this.$store.commit('DESTROY_NAME')
            this.$store.commit('SET_NAME', response.data.user)
            localStorage.setItem('name', response.data.user)
            this.$store.commit('SET_TIMEZONE', response.data.timezone)
            this.$store.commit('SET_USER_TIMEZONE', response.data.timezone)
            localStorage.setItem('timezone', response.data.timezone)
            localStorage.setItem('user_timezone', response.data.timezone)
            this.notifyVueSuccess(response.data.message)
            this.isProgress = false
            this.isDisabledbtn = false
          })
          .catch(error => {
            this.notifyVueError(error.response.data.message)
            this.isProgress = false
            this.isDisabledbtn = false
          })
      }
    },

    updatePassword() {
      if (this.validatePassord()) {
        this.isProgress = true
        this.isDisabledbtn = true
        let url = process.env.VUE_APP_API_URL + '/user/profile/update/password'
        axios
          .post(
            url,
            {
              current_password: this.current_password,
              new_password: this.new_password,
              confirmation_password: this.confirmation_password,
              token: this.$store.state.token
            },
            {
              headers: {
                Accept: 'application/json',
                Authorization: 'Bearer ' + this.$store.state.token
              }
            }
          )
          .then(response => {
            this.notifyVueSuccess(response.data.message)
            this.isProgress = false
            this.isDisabledbtn = false
          })
          .catch(error => {
            this.notifyVueError(error.response.data.message)
            this.isProgress = false
            this.isDisabledbtn = false
          })
      }
    },

    validateData() {
      if (!this.validEmail(this.profile.email)) {
        this.notifyVueError(' Enter an email with an appropriate format')
        this.$refs.email.$el.focus()
        return false
      } else if (this.profile.name == '') {
        this.notifyVueError(' The field user name required')
        this.$refs.name.$el.focus()
        return false
      } else {
        return true
      }
    },

    validatePassord() {
      if (this.current_password == '' || this.current_password == null) {
        this.notifyVueError(' The current password is requird')
        this.$refs.current_password.$el.focus()
        return false
      } else if (this.new_password == '' || this.new_password == null) {
        this.notifyVueError(' The field new password is required')
        this.$refs.new_password.$el.focus()
        return false
      } else if (
        this.confirmation_password == '' ||
        this.confirmation_password == null
      ) {
        this.notifyVueError(' The field new password is required')
        this.$refs.confirmation_password.$el.focus()
        return false
      } else if (this.new_password != this.confirmation_password) {
        this.notifyVueError(
          ' The password and the confirmation password do not match'
        )
      } else {
        return true
      }
    },

    validEmail(email) {
      let emailRegex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
      if (emailRegex.test(email)) {
        return true
      } else {
        return false
      }
    },

    loadSettings() {
      let urlSettings = process.env.VUE_APP_API_URL + '/settings/user/index'
      axios
        .post(
          urlSettings,
          {
            user_id: this.$store.state.id
          },
          {
            headers: {
              Accept: 'application/json',
              Authorization: 'Bearer ' + this.$store.state.token
            }
          }
        )
        .then(response => {
          this.settings = response.data.settings
          this.fields = response.data.fields

          this.settings.forEach((value, index, array) => {
            if (array[index].type === 'notifications') {
              let notiSetting = array[index].value
              this.smsemail = notiSetting.split(',')[0]
              this.value = notiSetting.split(',')[1]
              this.typeday = notiSetting.split(',')[2]
            }
          })
        })
        .catch(error => {
          this.notifyVueError(error.response.data.message)
        })
    },

    updateSettings() {
      let url = process.env.VUE_APP_API_URL + '/settings/user/update'

      //Validate Notification Settings
      if (
        this.smsemail === undefined ||
        this.smsemail === null ||
        this.smsemail === ''
      ) {
        this.notifyVueError('Select Notification type on settings')
        return
      }

      if (
        this.value === undefined ||
        this.value === null ||
        this.value === '' ||
        isNaN(this.value)
      ) {
        this.notifyVueError('The time for notification settings is not valid')
        return
      }

      if (
        this.typeday === undefined ||
        this.typeday === null ||
        this.typeday === ''
      ) {
        this.notifyVueError('Select Notification interval on the settings')
        return
      }

      let notiSetting = [this.smsemail, this.value, this.typeday].join(',')
      console.log({
        notiSetting
      })
      this.settings.forEach((value, index, array) => {
        if (array[index].type === 'notifications') {
          array[index].value = notiSetting
        }
      })

      console.log({
        settings: this.settings
      })
      axios
        .post(
          url,
          {
            settings: this.settings
          },
          {
            headers: {
              Accept: 'application/json',
              Authorization: 'Bearer ' + this.$store.state.token
            }
          }
        )
        .then(response => {
          this.loadSettings()
          this.notifyVueSuccess(response.data.message)
        })
        .catch(error => {
          this.notifyVueError(error.response.data.message)
        })
    },

    getnumber(str) {
      var num = str.replace(/[^0-9]/g, '')
      return parseInt(num, 10)
    },

    notifyVueError(text) {
      this.$notify({
        message: '<b>Ups! </b>' + text + '',
        icon: 'add_alert',
        horizontalAlign: 'right',
        verticalAlign: 'top',
        type: 'danger'
      })
    },

    notifyVueSuccess(text) {
      this.$notify({
        message: '<b>Success! </b>' + text + '',
        icon: 'add_alert',
        horizontalAlign: 'right',
        verticalAlign: 'top',
        type: 'success'
      })
    }
  }
}
</script>

<style scoped>
.more-settings {
  position: absolute !important;
  z-index: 9 !important;
  top: 0px !important;
  right: 18px !important;
  border-radius: 100% !important;
}

.btn-edit {
  float: right !important;
}
</style>

<style>
.tab-pane-3 {
  width: 100% !important;
}

@media (max-width: 768px) {
  #settings .md-list.nav-tabs.md-theme-default {
    display: block;
  }
  .md-card-content {
    padding: 0px;
  }
  .md-dialog-container {
    width: 100%;
    height: fit-content;
  }
}
</style>
